var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6835 9.76656C3.30601 9.76656 3 10.0726 3 10.45V14.3165C3 14.694 3.30601 15 3.6835 15H7.54998C7.92743 15 8.23345 14.694 8.23345 14.3165C8.23345 13.939 7.92743 13.633 7.54998 13.633H5.33362L8.35543 10.6112C8.62238 10.3442 8.62238 9.91144 8.35543 9.6445C8.08857 9.37763 7.65579 9.37763 7.38885 9.6445L4.367 12.6664V10.45C4.367 10.0726 4.06098 9.76656 3.6835 9.76656ZM9.76628 3.68373C9.76628 3.30625 10.0723 3.00023 10.4498 3.00023H14.2986C14.4795 2.99555 14.6618 3.0622 14.7998 3.20019C14.9378 3.33819 15.0045 3.52052 14.9998 3.70134V7.55019C14.9998 7.92771 14.6938 8.23373 14.3162 8.23373C13.9388 8.23373 13.6328 7.92771 13.6328 7.55019V5.33385L10.6109 8.35572C10.3439 8.62266 9.91123 8.62266 9.64429 8.35572C9.37735 8.08877 9.37735 7.656 9.64429 7.3891L12.6661 4.36724H10.4498C10.0723 4.36724 9.76628 4.06122 9.76628 3.68373Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/Preview.262b2ea76f535be440652a2af809d6cc.svg";
export { ForwardRef as ReactComponent };